module.exports = __webpack_public_path__ + "static/media/offices (9).ac26f2ef.webp";